import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/view-order-image";

export class ViewOrderImageView extends View {

    static classname = "view-order-image";

    private readonly server = Server.instance();

    private id : string;

    private url? : string;

    constructor(id: string) {
        super(ViewOrderImageView.classname);
        this.id = id;
        this.refresh();
    }

    refresh() {
        const q_ = this.server.getOrderImageUrl(this.id);
        q_.then((url) => {
            this.url = url;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            url: this.url,
        };

        const out = this.pug(template, data);

        return out;
    }
}
